import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { isAppointmentNotificationDetails as typeGuard } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";

export { default } from "./NotificationAppointmentApproved.vue";

export const selector = (item: Notification): boolean => {
  return typeGuard(item.details) && item.type === NotificationType.APPOINTMENT_APPROVED;
};
